import React, { Component } from 'react';

class SportsGrid extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
        this.handleSingleEventsClick = this.handleSingleEventsClick.bind(this);
    }
    handleSingleEventsClick() {

    }
    render() {
        return (
            <div className="select-sport">
                <div className="heading-wrap animated bounce">
                    <div className="main-heading-title">
                        <span className="heading-number">1</span>
                        Select a Sport
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 select-sport-info">
                        <div className="sub-item-wrapper">
                            {/* <div className="subheading"><span className="subheading-number">1.1</span>HEADING</div> */}
                            <div className="info-description">Mevu will make it easy to see which sports are available to be bet upon. There will be a wide variety available at launch and more
will be added with popular demand.</div>
                        </div>
                        {/* <div className="sub-item-wrapper">
                            <div className="subheading"><span className="subheading-number">1.2</span>HEADING</div>
                            <div className="info-description">Lorem ipsum dolor sit amet, consectetuer adipisc
                            ing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.
                            Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl
                            ut aliquip ex ea commodo consequat.</div>
                        </div> */}
                    </div>
                    <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 select-sport-grid-wrap">
                        <div className="row select-sport-grid">
                            <div className="col-3 select-sport-grid-col">
                                <div className="imgContainer">
                                    <div className="grid-item">
                                        <div className="imgContainer">
                                            <img src="img/icons/soccer.png" />
                                        </div>
                                        <div className="grid-content">
                                            <h4>soccer</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/hockey.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>Hockey</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/basketball.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>Basketball</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/baseball.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>Baseball</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/football.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>football</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/golf.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>golf</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/tennis.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>tennis</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/volleyball.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>volleyball</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/esports.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>e-sports</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/mma.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>mma</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/boxing.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>boxing</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/cricket.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>cricket</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/pool.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>pool</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/racing.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>racing</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/aussierules.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>aussie rules</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-3 select-sport-grid-col">
                                <div className="grid-item">
                                    <div className="imgContainer">
                                        <img src="img/icons/darts.png" />
                                    </div>
                                    <div className="grid-content">
                                        <h4>darts</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SportsGrid;



// WEBPACK FOOTER //
// ./src/Components/SportsGrid.js